import { gql, useMutation } from "@apollo/client";

export const FORCE_REFRESH_MUTATION = gql`
  mutation forceRefreshPmxActivity($activityId: ID!) {
    forceRefreshPmxActivity(input: { activityId: $activityId })
  }
`;

export function useForceRefreshPmxActivity(activityId: string) {
  const [
    forceRefreshPmxActivity,
    {
      data: dataRefreshPmxActivity,
      loading: isRefreshPmxActivityLoading,
      error: errorRefreshPmxActivity
    }
  ] = useMutation(FORCE_REFRESH_MUTATION, {
    variables: {
      activityId
    }
  });

  return {
    dataRefreshPmxActivity: dataRefreshPmxActivity?.forceRefreshPmxActivity,
    forceRefreshPmxActivity,
    isRefreshPmxActivityLoading,
    errorRefreshPmxActivity
  };
}
